import React, { useState, useEffect } from "react";

export function InnTextbox(props) {
  const [textvalue, settextvalue] = useState(props.value);
  //For Display Error Message Varible
  const [inputErrors, setinputErrors] = useState(false);
  const [errorMessage, seterrorMessage] = useState(false);
  const [errorstring, seterrorstring] = useState("");

  useEffect(() => {
    settextvalue(props.value);
  }, [props.value]);

  //change event of textbox start
  const handlechange = (e) => {
    settextvalue(e.target.value);
    txtValidation(e.target.value);
    if (props.onChange) {
      props.onChange(e.target.value, e);
    }
  };
  //change event of textbox end

  //Textbox validation function start
  const txtValidation = (val) => {
    if (val != "") {
      setinputErrors(false);
      seterrorMessage(false);
      seterrorstring("");
      if (props.type == "password") {
        if (val.length < props.min || val.length > props.max) {
          setinputErrors(true);
          seterrorMessage(true);
          seterrorstring(
            "Password should be min  " +
              props.min +
              " char and max " +
              props.max +
              " char"
          );
        }
      } else if (props.type == "email") {
        if (
          new RegExp(/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,15}/g).test(val) ==
          false
        ) {
          setinputErrors(true);
          seterrorMessage(true);
          seterrorstring("Please Enter Valid Email Address...");
        }
      } else if (props.customError && props.customError.length > 0) {
        setinputErrors(true);
        seterrorMessage(true);
        seterrorstring(props.customError);
      } else {
        if (props.required == true && val == "") {
          setinputErrors(true);
          seterrorMessage(true);
          seterrorstring("Field is Required..");
        } else {
          setinputErrors(false);
          seterrorMessage(false);
          seterrorstring("");
        }
      }
    }
  };
  //Textbox validation function end

  //Focus Event For validation start
  const handleFocus = (e) => {
    if (e.target.value == "") {
      setinputErrors(true);
      seterrorMessage(true);
      if (props.required == true && e.target.value == "") {
        seterrorstring("Field is Required..");
      } else {
        setinputErrors(false);
        seterrorMessage(false);
        seterrorstring("");
      }
    }
  };
  //Focus Event For Validation end

  //#region handleOnKeyDown
  const handleOnKeyDown = (e) => {
    if(props.tag == "integer"){
      if((e.keyCode >= 48 && e.keyCode <= 57 && e.shiftKey == false ) || (e.keyCode >= 96 && e.keyCode <= 105 && e.shiftKey == false ) || (e.keyCode == 8 && e.shiftKey == false ) || (e.keyCode == 9 && e.shiftKey == false ) || (e.keyCode == 37) || (e.keyCode == 39) || (e.keyCode == 46 && e.shiftKey == false ))
      {}
      else
      {             
          e.preventDefault();
      }
    }
    else if(props.tag == "decimal"){
      if((e.keyCode >= 48 && e.keyCode <= 57 && e.shiftKey == false ) || (e.keyCode >= 96 && e.keyCode <= 105 && e.shiftKey == false ) || (e.keyCode == 8 && e.shiftKey == false ) || (e.keyCode == 9 && e.shiftKey == false ) || (e.keyCode == 37) || (e.keyCode == 39) || (e.keyCode == 46 && e.shiftKey == false ) || (e.keyCode == 110 && e.shiftKey == false ) || (e.keyCode == 190 && e.shiftKey == false ))
      {
        if(textvalue.toString().split('.').length <= 1 ){}
        else
        {
          if((e.keyCode == 110 && e.shiftKey == false ) || (e.keyCode == 190 && e.shiftKey == false )){
            e.preventDefault();
          }
        }
      }      
      else
      {             
          e.preventDefault();
      }
    }
  }
  //#endregion handleOnKeyDown
  
  //for customerror useeffect start
  useEffect(() => {
    if (props.customError && props.customError.length > 0) {
      setinputErrors(true);
      seterrorMessage(true);
      seterrorstring(props.customError);
    } else {
      setinputErrors(false);
      seterrorMessage(false);
      seterrorstring("");
    }
  }, [props.customError]);
  //for customerror useeffect end

  return (
    <div
      className={
        props.disabled == true ? props.className + " disabled" : props.className
      }
    >
      <input
        type={props.type}
        value={textvalue}
        className="form-field"
        placeholder={props.placeholder || props.children}
        onChange={handlechange}
        onClick={props.onClick}
        disabled={props.disabled}
        onFocus={handleFocus}
        customError={props.customError}
        onBlur={props.onBlur}
        id={props.id}
        onKeyDown={handleOnKeyDown}
        maxLength={props.maxlength != undefined ? props.maxlength :null}
        //customErrorShow={props.customErrorShow}
      />
      <label className="form-label">{props.children}</label>
      {inputErrors == true && errorMessage == true ? (
        <div class="error">
          <span>{errorstring}</span>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
}

export function InnPlainTextbox(props) {
  return <input type="text"></input>;
}
